module.exports = __webpack_public_path__ + "fwm_h5/img/DuomuyuanLogo.6ffc3d0c.png";